<p-toast/>

<header class="h-16 bg-white border-b border-slate-200 flex items-center px-4 sm:px-6">
  <div class="flex items-center gap-2">
    <span class="pi pi-bolt text-primary text-xl"></span>
    <span class="font-semibold">Energy Comparator</span>
  </div>

  <div class="ml-auto flex items-center gap-2">
    <p-popover #helpMenu>
      <ng-template pTemplate="content">
        <ul class="list-none p-2 w-64">
          <li class="p-2 hover:bg-slate-100 cursor-pointer" (click)="abrirModalError()">
            <i class="pi pi-exclamation-triangle mr-2"></i> Reportar un error
          </li>
          <li class="p-2 hover:bg-slate-100 cursor-pointer" (click)="abrirPagina('aviso-legal')">
            <i class="pi pi-file mr-2"></i> Aviso legal
          </li>
          <li class="p-2 hover:bg-slate-100 cursor-pointer" (click)="abrirPagina('privacidad')">
            <i class="pi pi-shield mr-2"></i> Política de privacidad
          </li>
          <li class="p-2 hover:bg-slate-100 cursor-pointer" (click)="abrirPagina('cookies')">
            <i class="pi pi-circle-on mr-2"></i> Política de cookies
          </li>
          <li class="p-2 hover:bg-slate-100 cursor-pointer" (click)="abrirPagina('condiciones')">
            <i class="pi pi-list mr-2"></i> Condiciones de uso
          </li>
        </ul>
      </ng-template>
    </p-popover>

    <p-button
      icon="pi pi-question-circle"
      styleClass="p-button-text p-button-rounded"
      (click)="helpMenu.toggle($event)"
    ></p-button>

    <p-button
      icon="pi pi-bell"
      styleClass="p-button-text"
      aria-label="Notificaciones"
    ></p-button>

    <p-tieredMenu [model]="items" [popup]="true" #menu/>

    <button pButton class="p-button-text flex items-center gap-2" type="button"
            (click)="menu.toggle($event)" aria-haspopup="true" aria-controls="user_menu">
      <p-avatar icon="pi pi-user" shape="circle" size="large"></p-avatar>
      <span class="hidden sm:inline">Mi cuenta</span>
      <i class="pi pi-angle-down hidden sm:inline"></i>
    </button>
  </div>
</header>

<app-reportar-error-dialog [(visible)]="modalErrorVisible"/>
<app-legal-dialogs [(visible)]="legalVisible" [tipo]="legalTipo"/>
